// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"2":"408ef7f4","120":"a7482839","140":"4a99deda","407":"ece1f55d","544":"1f66e5d9","767":"07d417cc","790":"1b6183c9","800":"104a0636","895":"3464f22d","969":"ee687ed2"}[chunkId] + ".chunk.js";
};